import React from "react";
import styled from "styled-components";
import { IconSvg } from "monica-alexandria";
import {
    read_timeline_changes,
    read_timeline_note_label
} from "../../utils/timeline/timeline_formatting";
import { Timeline_Detail } from "./Timeline_Detail";

const TimelineBrandUpdate = styled.div`
    display: grid;
    gap: 0.4rem;
`;

const TimelineBrandChange = styled.div`
    display: grid;
    grid-template-columns: minmax(8rem, 12rem) minmax(0, 1fr);
    gap: 0.6rem;
    align-items: center;

    > h6 {
        color: ${p => p.theme.mid};
        overflow-wrap: anywhere;
    }
`;

const TimelineChangeValue = styled.p`
    min-width: 0;
    flex: 0 1 auto;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
`;

const TimelinePreviousValue = styled(TimelineChangeValue)`
    color: var(--error);
`;

const TimelineCurrentValue = styled(TimelineChangeValue)`
    color: var(--success);
`;

const TimelineChangeFlow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
`;

const TimelineChangeIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.4rem;
    color: ${p => p.theme.mid};

    svg {
        width: 1.4rem;
        height: 1.4rem;
        fill: currentColor;
    }
`;

// Displays each changed field as one compact previous-to-current row.
export const Timeline_Brand_Update = (props) => {
    return (
        <TimelineBrandUpdate>
            {read_timeline_changes(props.event).map((change) => (
                <TimelineBrandChange key={`${props.event?.eventId || props.event?.sourceKey}-${change.field}`}>
                    <h6>{props.t(change.field)}</h6>
                    <TimelineChangeFlow>
                        <TimelinePreviousValue>{change.from}</TimelinePreviousValue>
                        <TimelineChangeIcon>
                            <IconSvg Icon="Next" />
                        </TimelineChangeIcon>
                        <TimelineCurrentValue>{change.to}</TimelineCurrentValue>
                    </TimelineChangeFlow>
                </TimelineBrandChange>
            ))}
            <Timeline_Detail label={props.t("Note")} value={read_timeline_note_label(props.event)} />
        </TimelineBrandUpdate>
    );
};
